import template from './header.html';
import controller from './header.controller';
import './header.scss';

let headerComponent = {
  restrict: 'E',
  bindings: {
    title: '@'
  },
  template,
  controller,
  transclude : {
    'previous': '?previous',
    'extra': '?extra',
    'subItem': '?subItem'
  }
};

export default headerComponent;
